import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { ShopCartIconHttpService } from '@common/services/REST/shop-cart-icon.http.service';
import * as CartIconActions from './shop-cart-icon.actions';
import { ShopCartIconSettingsType } from '@common/types/shop-cart-icon-settings.type';

@Injectable()
export class ShopCartIconEffects {
    private actions$ = inject(Actions);
    private iconService = inject(ShopCartIconHttpService);

    loadCartIcon$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CartIconActions.loadCartIcon),
            mergeMap(({ siteId }) =>
                this.iconService.getIconStyle(siteId).pipe(
                    map((res) =>
                        CartIconActions.loadCartIconSuccess({ data: res.data, isCartEnabled: res.isCartEnabled })
                    ),
                    catchError((error) => of(CartIconActions.loadCartIconFailure({ error })))
                )
            )
        )
    );

    saveCartIcon$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CartIconActions.saveCartIcon),
            map(({ data }) => CartIconActions.saveCartIconSuccess({ data }))
        )
    );
}
